import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DatasService } from 'src/app/services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';
import { TunnelService } from 'src/app/services/tunnel.service';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { CurrentService } from 'src/app/services/current.service';

@Component({
  selector: 'ng-casto-storage-room',
  templateUrl: './room.component.html',
  host: { class: 'container' },
})
export class StorageRoomComponent implements OnInit {
  @Output() onComplete: EventEmitter<void> = new EventEmitter();
  @Output() onSkipStep: EventEmitter<void> = new EventEmitter();

  inspirations: any[];

  constructor(
    public current: CurrentService,
    public gtm: GTM,
    public datas: DatasService,
    public router: Router,
    public tunnelService: TunnelService,
    public tunnelDataStore: TunnelDataStore,
    private readonly customer: CustomerService
  ) {}

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/chambre`, 'Rangements | Choix', {
      stepNumber: 1,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });

    this.inspirations = this.datas.storage.inspirations.sort((a: any, b: any) => {
      return a.rank - b.rank;
    });
  }

  selectInspiration(inspirationId: number) {
    if (this.current.storage?.inspirationId !== inspirationId) {
      this.current.reset();
    }

    this.current.storage.inspirationId = inspirationId;

    if (inspirationId === 0) {
      this.onSkipStep.emit();
    } else {
      this.onComplete.emit();
    }
  }
}
